import { ABConfigsStore } from '@store/ab-configs'

export const compileAnalyticsEventProps = (eventProps: Record<string, any> = {}): Record<string, any> => {
  const {
    medSupQuotesFlag,
    medAdvQuotesFlag,
    lifeQuotesFlag,
    pdpQuotesFlag
  } = ABConfigsStore.getQuoteConfigsSync()

  return {
     uid: eventProps.userId,
     lid: eventProps.leadId,
     medsup_quotes: medSupQuotesFlag,
     medadv_quotes: medAdvQuotesFlag,
     life_quotes: lifeQuotesFlag,
     pdp_quotes: pdpQuotesFlag,
     ...eventProps
  }
}
